export type TrackingDrainState = { busy: boolean; retryAt: number };

/** One bounded batch, one sender, no immediate retry after an unconfirmed ACK. */
export async function flushTrackingQueue<T>(
  queue: T[],
  send: (batch: T[]) => Promise<boolean>,
  pick: (queue: T[]) => T[],
  state: TrackingDrainState,
  now: () => number = Date.now,
): Promise<boolean> {
  if (state.busy || state.retryAt > now() || queue.length === 0) return false;
  state.busy = true;
  const batch = pick(queue);
  try {
    if (batch.length && await send(batch)) {
      state.retryAt = 0;
      return true;
    }
  } catch {
    // Transport failures preserve the exact batch just like a rejected ACK.
  } finally {
    state.busy = false;
  }
  queue.unshift(...batch);
  // Preserve oldest unacknowledged data within the existing 100-event budget.
  queue.splice(100);
  state.retryAt = now() + 30_000;
  return false;
}
